export enum LearningTypes {
  CATEGORY = 'category',
  CONTENT = 'content',
}
